import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'
import { ModalButton } from 'src/components/Global/Button/Button'
import { InvestCheckbox } from 'src/components/Global/CheckBox/Checkbox'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import BankTransfer from 'src/components/Payment/BankTransfer/BankTransfer'
import PaymentSelect from 'src/components/Payment/PaymentSelect/PaymentSelect'
import useUserData from 'src/hooks/useUserData'
import { useTypedSelector } from 'src/redux/root-reducer'
import { addNairaSign } from 'src/utils/addNairaSign'
import { action } from 'typesafe-actions'
import { createInvestmentAction } from 'src/redux/actions/invest'
import { FlexContent, InvestWrapper } from './investmentInfoStyle'
import useSnackbar from 'src/hooks/useSnackBar'
import { usePaystack } from 'src/utils/paystack'
import { InvestTypes } from 'src/redux/types/invest'

const InvestInfo = () => {
  const dispatch = useDispatch()
  const snackbar = useSnackbar()
  const navigate = useNavigate()

  const params = useParams()
  const { id } = params
  const { pay } = usePaystack()

  const USER_DATA = useUserData()

  const user_email = USER_DATA.user.email

  const investmentData = useTypedSelector((state) => state.invest.all.plans)
  const [quantity, setQuantity] = useState(1)
  const [toggleCheckBox, setToggleCheckBox] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [onIHavePaidModal, showOnIHavePaidModal] = useState(false)

  const [option, setOption] = useState({
    name: 'card',
    data: 'new',
  })
  const [account, setAccount] = useState({
    account_number: '',
    account_name: '',
    bank_name: '',
  })

  const data = investmentData?.filter((el: any) => {
    return el.id === id
  })

  const [investData] = data
  console.log(investData, 'invest')

  const increment = () => {
    setQuantity(quantity + 1)
  }
  const decrement = () => {
    if (quantity === 1) {
      return
    }
    setQuantity(quantity - 1)
  }

  const getEstimatedCost = () => {
    const minAmount = investData.minimum_amount
    //REMOVE ANY SPECIAL CHARACTER
    const newAmount = minAmount.toString().replace(/[^a-zA-Z0-9]/g, '')

    return addNairaSign(parseInt(newAmount, 10) * quantity)
  }

  const getMaturityDate = () => {
    const todayDate = new Date()
    const estimatedMaturityDate = todayDate.setMonth(investData.duration)

    return new Date(estimatedMaturityDate).toDateString()
  }

  const handleCheckBox = () => {
    setToggleCheckBox(!toggleCheckBox)
  }

  const createInvestment = () => {
    setLoading(true)
    const amount = investData.minimum_amount.replace(/[₦,""]/g, '')

    const payload = {
      investment_plan_id: investData?.id,
      amount: parseFloat(amount) * quantity,
      channel: option.name,
      card_id: option.data,
    }

    dispatch(
      createInvestmentAction({
        payload,
        onSuccess,
        onError,
      })
    )
  }

  const onSuccess = (data: any) => {
    console.log(data)
    // navigate(-1)
    setLoading(false)
    snackbar.trigger({
      message: data.server_response,
      severity: 'success',
    })

    const investAmount = investData.minimum_amount.replace(/[₦,""]/g, '')
    if (data.payment.bank_name) {
      onFundWithBankSuccess(data.payment)
    } else if (data.successful) {
      const payload = {
        reference: data.payment.reference,
        email: user_email,
        amount: parseFloat(investAmount) * 100 * quantity,
      }

      const onPaySuccess = () => {
        navigate(-1)
        snackbar.trigger({
          message: 'Payment successful',
          severity: 'success',
        })
      }
      const onClose = () => {
        snackbar.trigger({
          message: 'Payment failed, please try again',
          severity: 'error',
        })
      }
      pay(payload, onPaySuccess, onClose)
    } else {
      dispatch(action(InvestTypes.GET_ALL_INVESTMENTS_CALL))
    }
  }

  const onError = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'error',
    })
  }

  const onFundWithBankSuccess = (data: any) => {
    setShowModal(true)
    setAccount({
      ...account,
      account_number: data?.account_number,
      bank_name: data?.bank_name,
    })

    console.log(data)
  }

  const onIHavePaid = () => {
    // setShowModal(false)
    showOnIHavePaidModal(true)
  }

  const disabled = !toggleCheckBox || loading

  const amount = investData.minimum_amount.replace(/[₦,""]/g, '')

  return (
    <InvestWrapper>
      <div className="invest_img">
        <img src={investData.image} alt="" className="invest-image" />
      </div>
      <div className="invest">
        <h2 className="invest-title">{investData.plan_name}</h2>
        <p>{investData.description}</p>
      </div>

      <div className="sector_quantity">
        <div className="sector">
          <p className="insured_text">
            Insured:<span>{investData.insured ? 'Yes' : ''}</span>
          </p>
          <p className="amount_text">{investData.minimum_amount} per unit</p>
        </div>
        <div className="quantity">
          <p className="quantity_btn" onClick={decrement}>
            -
          </p>
          <p className="quantity_text">{quantity}</p>
          <p className="quantity_btn" onClick={increment}>
            +
          </p>
        </div>
      </div>

      <FlexContent>
        <div className="flex_one">
          <p>Interest Rate:</p>
          <p>Duration:</p>
          <p className="cost">Estimated Cost</p>
        </div>
        <div className="flex_two">
          <p>{investData.roi}% per annum</p>
          <p>{investData.duration} months</p>
          <p>{getEstimatedCost()}</p>
        </div>
      </FlexContent>

      <div className="payment_section">
        <PaymentSelect
          option={option}
          setPayWithMethod={setOption}
          plan={investData}
          // addNewCard={false}
        />
      </div>

      <div className="bank_transfer_wrapper">
        <BankTransfer
          account={account}
          amount={(parseFloat(amount) * quantity).toString()}
          showModal={showModal}
          setShowModal={setShowModal}
          onIHavePaid={onIHavePaid}
          showOnIHavePaidModal={showOnIHavePaidModal}
          onIHavePaidModal={onIHavePaidModal}
        />
      </div>

      <div className="verify_investment">
        <div className="check_container">
          <InvestCheckbox checked={toggleCheckBox} onChange={handleCheckBox} />
        </div>
        <p>
          {`You are about to invest ${getEstimatedCost()}, you will not be able to  withdraw till ${getMaturityDate()}`}
        </p>
      </div>

      <div className="invest_btn_container">
        <ModalButton
          onClick={createInvestment}
          className={`invest_btn ${disabled ? 'blur' : ''}`}
        >
          Proceed {loading && <Spinner />}
        </ModalButton>
      </div>
    </InvestWrapper>
  )
}

export { InvestInfo }
